function getUrlParam (name) { 
    var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)"); 
    var r = window.location.search.substr(1).match(reg); 
    if(r!=null)return unescape(r[2]); return null; 
}
function iosWakeUp(params){    
    // var data = OpenInstall.parseUrlParams();///openinstall.js中提供的工具函数，解析url中的所有查询参数
    var data =  params
    
    new OpenInstall({
        appKey : "iuhuyx",
        /*直接指定渠道编号，默认通过当前页url中的channelCode参数自动检测渠道编号*/
        //channelCode:"渠道编号",
        /*自定义遮罩的html*/
        //mask:function(){
        //  return "<div id='_shadow' style='position:fixed;left:0;top:0;background:rgba(0,255,0,0.5);filter:alpha(opacity=50);width:100%;height:100%;z-index:10000;'></div>"
        //},
        /*初始化完成的回调函数，可选*/
        onready : function() {
            /*在app已安装的情况尝试拉起app*/
            //this.schemeWakeup({data:data,channelCode:"test-channelcode"});//延迟指定绑定参数与渠道编号
            console.log('this.schemeWakeup',data);
            this.schemeWakeup({data:data});
            /*用户点击某个按钮时(假定按钮id为downloadButton)，安装app*/
            var m = this;
            //this.wakeupOrInstall({data:data,channelCode:"test-channelcode"});//延迟指定绑定参数与渠道编号
            console.log('m.wakeupOrInstall',data);
            m.wakeupOrInstall({data:data});
            /*跳过scheme拉起，直接安装*/
            //m.install({data:data,channelCode:"test-channelcode"});//延迟指定绑定参数与渠道编号
            return false;
        }
    }, data);
};

function toMLink(){
    const nuag = navigator.userAgent;
    const isAndroid = nuag.indexOf('Android') > -1 || nuag.indexOf('Adr') > -1;
    const isiOS = !!nuag.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); 
    const wakeupData={
        // 	newsId:'',
        newsType:12, // 6是首页 12 是投票详情页面
        // 	detailUrl:''	
    }
    wakeupData.detailUrl=window.location.href;
    wakeupData.newsId=getUrlParam("newid");
    if((isiOS||isAndroid)&&!/(zonglan6756)/i.test(navigator.userAgent)){        
        iosWakeUp(wakeupData)
    }
    
}

export default {toMLink}




